import {SvgIcon, SvgIconProps} from "@mui/material";

export default function CreditCard(props: SvgIconProps) {
        const {viewBox, ...restProps} = props;
    return (
        <SvgIcon {...restProps} viewBox={'0 0 51.767 33.803'}>
                    <path d="M63.153,319.6H107a3.972,3.972,0,0,1,3.961,3.963V349.44A3.969,3.969,0,0,1,107,353.4H63.153a3.969,3.969,0,0,1-3.961-3.961V323.561a3.972,3.972,0,0,1,3.961-3.963ZM107,321.216H63.153a2.353,2.353,0,0,0-2.344,2.345V349.44a2.35,2.35,0,0,0,2.344,2.344H107a2.35,2.35,0,0,0,2.344-2.344V323.561A2.353,2.353,0,0,0,107,321.216Z" 
                          transform="translate(-59.192 -319.598)"/>
                    <path d="M110.959,323.972v6.385H59.192v-7.194h51.767v.809Zm-1.618,4.767v-3.958H60.81v3.958Z" transform="translate(-59.192 -317.585)"/>
                    <path d="M63.039,334.546a.809.809,0,1,0,0,1.618h5.5a.809.809,0,1,0,0-1.618Z" transform="translate(-57.477 -311.159)"/>
                    <path d="M69.165,334.546a.809.809,0,1,0,0,1.618h5.5a.809.809,0,1,0,0-1.618Z" transform="translate(-54.019 -311.159)"/>
                    <path d="M75.291,334.546a.809.809,0,1,0,0,1.618h5.5a.809.809,0,1,0,0-1.618Z" transform="translate(-50.56 -311.159)"/>
                    <rect width="48.532" height="3.959" transform="translate(1.618 7.195)"/>
        </SvgIcon>
    );
}